<template>
  <div class="page-register">
    <div class="columns">
      <div class="column is-6 is-offset-3">
        <div class="box">

          <div class="tabs is-centered">
            <ul>
              <li><router-link to="/login">Login</router-link></li>
              <li class="is-active"><router-link to="/register">Sign Up</router-link></li>
            </ul>
          </div>

          <div class="columns">
            <div class="column is-8 is-offset-2">
              <div class="register-form form-horizontal">

                <div class="control notification is-danger" v-if="error">
                  <button class="delete" @click="error = undefined"></button>
                  {{ error }}
                </div>

                <form-input
                  type="email" name="email"
                  fa="user" mdi="email"
                  placeholder="Email"
                  :value="credentials.email"
                  @onInput="onInput"
                  :error="errors.email"
                  required=true
                  autofocus=true>
                </form-input>

                <form-input
                  type="text" name="name"
                  fa="user" mdi="person_outline"
                  placeholder="Username"
                  :value="credentials.name"
                  @onInput="onInput"
                  :error="errors.name"
                  required=true>
                </form-input>

                <form-input
                  type="password" name="password"
                  fa="lock" mdi="lock"
                  placeholder="Password"
                  :value="credentials.password"
                  @onInput="onInput"
                  :error="errors.password"
                  required=true>
                </form-input>

                <form-input
                  type="password" name="password_confirmation"
                  fa="lock" mdi="lock_outline"
                  placeholder="Confirm Password"
                  :value="credentials.password_confirmation"
                  @onInput="onInput"
                  :error="errors.password_confirmation"
                  required=true>
                </form-input>

                <p class="control submit">
                  <button class="button is-primary is-outlined is-fullwidth"
                    @click="submit()"
                    :class="{ 'is-loading': isLoading }">
                    Register
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from '@/apis/Auth'
export default {
  data () {
    return {
      rememberMe: false,
      credentials: {
        email: '',
        name: '',
        password: '',
        password_confirmation: ''
      },
      isLoading: false,
      error: '',
      errors: []
    }
  },
  methods: {
    submit () {
      this.error = ''
      this.errors = []
      this.isLoading = true

      auth.register(this.credentials)
      .then(data => {
        this.isLoading = false
        // data:
        // {
        // "data":
        // {
        // "identifier":1,
        // "name":"admin",
        // "email":"admin@noctorus.net",
        // "isVerified":0,
        // "creationDate":"2017-07-27 14:53:57",
        // "modifiedDate":"","deletedDate":null
        // }
        // }
        // need token?
        this.$router.push('/login?verify=true')
      })
      .catch(error => {
        console.error('register failed', error)
        if (error.error && typeof error.error === 'object') {
          this.errors = error.error
        } else if (error.error && typeof error.error === 'string') {
          this.error = error.error
        }

        this.isLoading = false
      })
    },
    onInput ({ name, value }) {
      if (!name || !this.credentials.hasOwnProperty(name)) {
        console.error('invalid update key: ' + name)
        return
      }
      this.credentials[name] = value
    }
  },
  created () {
    console.log('created Register.vue')
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-register {
}
</style>



// WEBPACK FOOTER //
// Register.vue?2683f86f